import React from "react";

const apiUrl = {
  url: process.env.REACT_APP_API_URL,
};
export default { apiUrl };
